import { PageIntro } from "@/components/kit/PageIntro";
import { FaqContact, useFaqs } from "@/components/blocks/FaqContact";
import { JsonLd, faqSchema, usePageMeta } from "@/components/site/Seo";

export default function FaqPage() {
  usePageMeta("FAQ", "Answers about the 120-day programme, cost, results, and how a wellness coach differs from a dietitian.");
  const faqs = useFaqs();
  return (
    <div data-testid="faq-page">
      <JsonLd id="faq" data={faqSchema(faqs)} />
      <PageIntro testId="faq-hero" eyebrow="FAQ" lines={["Good questions.", <em key="h" className="text-gold-soft">Honest answers.</em>]} intro="If yours isn't here, ask it in your free consultation or send a WhatsApp. No question is too small." />
      <FaqContact idPrefix="faq-contact" />
    </div>
  );
}
